/**
 * Funding & Costs — Inputs step for Planisware FIN peer of hours.
 * Weekly approved envelope + per-priority launch cost plans.
 */

import { Link } from 'react-router-dom';
import { FundingWorkbenchPanel } from '../../../components/planning/timePhased/FundingWorkbenchPanel';
import { TimePhasedModuleGate } from '../../../components/planning/timePhased/TimePhasedModuleGate';
import { usePlanningEngine } from './PlanningEngineContext';

function FundingCostsInner() {
  const { projectId, activeScenario } = usePlanningEngine();

  if (!activeScenario) {
    return (
      <div className="p-6">
        <p className="text-sm text-[var(--text-sec)] dark:text-[var(--text-sec)]">
          Select or create a scenario in the scope bar above to edit funding and launch costs.
        </p>
        <Link
          to="/planning/engine/scenarios"
          className="text-sm text-primary-600 hover:underline mt-2 inline-block"
        >
          Go to Scenarios →
        </Link>
      </div>
    );
  }

  if (!projectId) {
    return (
      <div className="p-6">
        <p className="text-sm text-[var(--text-sec)] dark:text-[var(--text-sec)]">
          No planning project in scope. Open a plan cycle or create a scenario first.
        </p>
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto pb-8">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-[var(--text-pri)] dark:text-[var(--text-pri)]">
          Funding &amp; Costs
        </h2>
        <p className="text-sm text-[var(--text-ter)] dark:text-[var(--text-sec)]">
          Scenario: {activeScenario.name} · money peer of the supply calendar
        </p>
      </div>
      <FundingWorkbenchPanel
        projectId={projectId}
        scenarioId={activeScenario.id}
        horizonStart={activeScenario.horizonStartDate}
        horizonEnd={activeScenario.horizonEndDate}
        planningWeeks={activeScenario.planningWeeks}
      />
    </div>
  );
}

export default function FundingCostsPage() {
  return (
    <TimePhasedModuleGate>
      <FundingCostsInner />
    </TimePhasedModuleGate>
  );
}
